import request from '@/util/request';
import qs from 'qs';

// 派单规则分页接口
export const getList = (params, options) =>
  request.get('/api/v4ward/order/appoint/page', Object.assign({}, options, { params }));

export const add = (params, options) =>
  request.post('/api/v4ward/order/appoint/save', params, options);

export const remove = (params, options) =>
  request.post('/api/v4ward/order/appoint/remove', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/order/appoint/update', params, options);

export const getDetail = (params, options) =>
  request.get('/api/v4ward/order/appoint/detail', Object.assign({}, options, { params }));

// 获取工单子类型
export const getSubModuleList = (params, options) =>
  request.get('/api/v4ward/order/execute/getSubModuleListByOrderFlag', Object.assign({}, options, { params }));

// 获取项目下的所有部门
export const getDeptTreeByProjectId = (params, options) =>
  request.get('/api/v4ward/dept/treeByProjectDeptId', Object.assign({}, options, { params }));

// 获取指定工单类型下的所有人员列表
export const getUserListByModuleType = (params, options) =>
  request.get('/api/v4ward/order/appoint/getGroupDetails', Object.assign({}, options, { params }));